import styled from 'styled-components';

const LinkButton = styled.div`
	color: blue;
	border-bottom: 1px solid blue;
	width: max-content;
	cursor: pointer;
`;

const LinkView = styled.span`
	color: blue;
	border-bottom: 1px solid blue;
	width: max-content;
	cursor: pointer;
`;

const Center = styled.div`
	display: grid;
	place-items: center;
	height: 100%;
	width: 100%;
`;
const AgreementButton = styled.div`
	padding: 10px;
	background-color: #f7f7f7;
	border: 1px solid #dfdfdf;
	border-top: none;
	text-align: right;
	button {
		margin-left: 10px;
	}
`;

const PaymentHeader = styled.h6`
	font-weight: bold;
	width: 100%;
	border-bottom: 1px solid;
	margin-bottom: 20px;
`;

const NestedTableData = styled.div`
	.ant-table.ant-table-bordered .ant-table-container {
		padding: 0px;
		border: 0;
	}
	.ant-table-content {
		padding: 0px !important;
	}
	.ant-table-thead {
		th {
			border-color: white !important;
			padding: 8px !important;
			&:last-child {
				border-right: none !important;
			}
		}
	}
	.ant-table-row {
		td {
			padding: 8px !important;
		}
	}
	.ant-table-summary {
		border: 1px solid rgba(0, 0, 0, 0.05);
		background: #fafafa;
		td {
			padding: 4px !important;
			border: 1px solid #59597759;
			border-right: 1px solid #aaaaaa !important;
		}
	}
`;
export const DocUpload = styled.div`
	margin: 6px 0;
	.ant-upload,
	.ant-upload button {
		width: 100%;
	}
	.ant-upload-list.ant-upload-list-text {
	}
	.ant-upload-list-item {
		margin: 0 6px;
		border: 1px solid #dfdfdf;
	}
`;

const SharedViewData = styled.div`
	color: black;
	h5 {
		font-weight: 600;
	}
	h6 {
		font-weight: bold;
	}
	p {
		font-weight: semi-bold;
		span {
			font-weight: 500;
		}
		margin: 0;
		margin-bottom: 8px;
	}
	.special-view {
		background-color: #f7f7f7;
		border: 1px solid #dfdfdf;
		border-radius: 4px;
		h5 {
			margin: 0;
			padding: 8px 10px;
			border-bottom: 1px solid #dfdfdf;
			background-color: #eeeeee;
			font-weight: bold;
			color: #535353;
			font-size: 16px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.special-edit {
				height: 24px;
			}
		}
		.special-area {
			padding: 10px;
		}
	}
`;

const SharedViewDataPlain = styled.div`
	color: black;
	h5 {
		font-size: 16px;
		line-height: 20px;
		font-weight: 600;
		margin: 0;
	}
	.sub-header {
		color: green;
		border-bottom: 1px solid;
		margin: 16px 0 6px 0;
		width: max-content;
	}
	h6 {
		font-size: 14px;
		font-weight: 600;
		display: inline-block;
		margin: 0;
		padding-top: 4px;
		padding-bottom: 4px;
	}
	p {
		display: inline-block;
		font-size: 14px;
		font-weight: 400;
		margin: 0;
		padding-top: 4px;
		padding-bottom: 4px;
		margin-left: 3px;
	}
	.status-name {
		color: green;
		font-weight: 600;
	}
	.danger-text {
		color: red;
		font-weight: 600;
	}
	&.block-area {
		border: 2px solid #dfdfdf;
		background-color: #eeeeee;
		border-radius: 4px;
		padding: 10px;
	}
`;

const InputSpan = styled.span`
	input[type='number'],
	.ant-input-number-input {
		border-radius: 4px !important;
		padding-right: 0px !important;
	}
`;

const FlexAccHeader = styled.div`
	display: flex;
	/* align-items: center; */
	justify-content: space-between;
	.site_info {
		margin: 0;
		span {
			margin: 0 10px;
			&:first-child {
				margin-left: 0;
			}
			&:last-child {
				margin-right: 0px;
			}
		}
	}
	.ant-btn-sm {
		height: auto;
	}
	.ant-checkbox {
		border: 2px solid rgba(0, 0, 0, 0.85);
		border-radius: 6px;
	}
`;

const SingleSiteDiv = styled.div`
	box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
	border-radius: 4px;
	p {
		margin: 0;
		margin-bottom: 6px;
		span {
			font-weight: bold;
		}
	}
	overflow: hidden;
	.site-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #dfdfdf;
		padding: 10px 20px;
		h5 {
			margin: 0;
			font-size: 16px;
			font-weight: bold;
		}
	}

	label span:nth-child(1) {
		width: 16px;
		height: 16px;
	}

	label span:nth-child(2) {
		width: 100%;
	}

	.site-area {
		padding: 10px 20px;
	}
	.site-button {
		button {
			padding: 0;
			height: 24px;
			width: 24px;
		}
	}
	.ant-radio {
		position: absolute;
		top: 13px;
		left: 10px;
	}
	span.ant-radio + * {
		padding: 0;
	}
	.site-radio-hide {
		.ant-radio {
			display: none;
		}
	}
	.site-radio-show {
		.site-approved {
			h5 {
				margin-left: 10px;
			}
		}
	}
`;

const MasterGridApi = styled.div`
	.mg {
		border: none;
	}
	.mg-title-area {
		display: none;
	}
	.mg-search-filter {
		display: none;
	}
	.sa-field-handler {
		display: none !important;
	}
	.ant-table-filter-trigger {
		display: none !important;
	}
	.ant-table-column-sorter-full {
		display: none !important;
	}
	th .ant-table-selection {
		visibility: hidden !important;
	}
	.mg-table .ant-table .ant-table-container {
		padding: 0 !important;
	}

`;
	// .sa-action-wraps {
	// 	padding: 10px 0 !important;
	// }
const SoftCopy = styled.div`
	width: max-content;
	background: black;
	border: 1px solid green;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	cursor: pointer;
	user-select: none;
	transition: all 0.2s;
	padding: 10px;
	font-weight: bold;
	width: 85px;
	height: 85px;
	font-size: 10px;
	color: white;
	span {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	i {
		margin-right: 6px;
	}
	strong {
		width: max-content;
		padding: 0 5px;
		background: #ffffff;
		border-radius: 50%;
		font-size: 12px;
		margin-bottom: 2px;
		color: #000000;
	}
	:hover {
		background: green;
	}
	:active {
		transform: scale(0.95);
	}
`;

const DangerousHtml = styled.div`
	overflow: hidden;
	table {
		width: 100%;
		border-collapse: collapse;
		border-spacing: 0;
		border: 1px solid;
		td {
			border: 1px solid;
			padding: 5px;
		}
	}
`;

const ManualGrid = styled.div`
	.ant-table-tbody > tr.ant-table-row:hover > .ant-table-cell-fix-left {
		background: #ffffff !important;
	}
`;

const TabScroll = styled.div`
	white-space: nowrap;
	overflow-x: auto;
	::-webkit-scrollbar {
		height: 6px;
		border-radius: 6px;
	}
	::-webkit-scrollbar-track {
		background: #f1f1f1;
		overflow: hidden;
	}
	::-webkit-scrollbar-thumb {
		background: #1e1e2d;
	}
	::-webkit-scrollbar {
		-ms-overflow-style: none;
		scrollbar-width: none;
	}
`;

const SharedTab = styled.div`
	border: 1px solid #dfdfdf;
	border-radius: 4px;
	.agreement-title {
		margin: 0;
		padding: 8px 10px;
		border-bottom: 1px solid #dfdfdf;
		background-color: #eeeeee;
		font-weight: bold;
		color: #535353;
		font-size: 16px;
	}
`;

const SharedManualTable = styled.table`
	width: 100%;
	color: #000 !important;
	thead {
		background-color: #1e1e2d;
		border: 1px solid #1e1e2d;
		color: #fff;
	}
	tr:nth-child(odd) {
		background: #fff;
	}
	tr:nth-child(even) {
		background: #e7e7e7;
	}
	th {
		background-color: #1e1e2d;
		border-right: 1px solid #595977;
		color: #fff;
		border-radius: 0;
		padding: 5px;
		font-weight: 500;
		text-align: left;
		font-size: 13px !important;
	}
	td {
		border: 1px solid rgba(89, 89, 119, 0.34901960784313724);
		padding: 2px 5px;
		font-size: 12px !important;
	}
	.ant-form-item {
		margin: 0;
	}
`;

const SmallerTab = styled.div`
	.react-tabs__tab-list {
		margin-bottom: 10px;
	}
	.react-tabs__tab {
		padding: 4px 8px;
		font-size: 12px;
	}
	.react-tabs__tab--selected:before {
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-top: 8px solid #007e3a;
	}
`;

// const SharedTable = styled.div`
// 	.ant-table.ant-table-bordered {
// 		border: 0;
// 	}
// 	.ant-table.ant-table-bordered .ant-table-container {
// 		padding: 0px;
// 		border: 0;
// 	}
// 	.ant-table-content {
// 		padding: 0px !important;
// 	}
// 	.ant-table-summary {
// 		border: 1px solid rgba(0, 0, 0, 0.05);
// 		background: #fafafa;
// 		td {
// 			padding: 4px !important;
// 			border: 1px solid #59597759;
// 			border-right: 1px solid #aaaaaa !important;
// 		}
// 	}
// 	&.extra-cols {
// 		.ant-table-cell {
// 			min-width: 120px;
// 			&:first-child {
// 				min-width: 50px;
// 			}
// 		}
// 		.ant-table-cell-fix-right-first {
// 			min-width: 60px !important;
// 			outline: 1px solid #59597722;
// 		}
// 		.ant-table-cell-fix-right {
// 			min-width: 200px;
// 			outline: 1px solid #59597722;
// 		}
// 		th {
// 			&.ant-table-cell-fix-right-first {
// 				outline: 1px solid #595977;
// 			}
// 			&.ant-table-cell-fix-right {
// 				outline: 1px solid #595977;
// 			}
// 		}
// 	}
// 	&.extra-cols-ps {
// 		.ant-table-cell {
// 			min-width: 120px;
// 			&:first-child {
// 				min-width: 50px;
// 			}
// 		}
// 		.ant-table-cell-fix-right-first {
// 			outline: 1px solid #59597722;
// 		}
// 		.ant-table-cell-fix-right {
// 			outline: 1px solid #59597722;
// 		}
// 		th {
// 			&.ant-table-cell-fix-right-first {
// 				outline: 1px solid #595977;
// 			}
// 			&.ant-table-cell-fix-right {
// 				outline: 1px solid #595977;
// 			}
// 		}
// 	}
// `;

const SharedTable = styled.div`
	.ant-table.ant-table-bordered {
		border: 0;
	}
	.ant-table.ant-table-bordered .ant-table-container {
		padding: 0px;
		border: 0;
	}
	.ant-table-content {
		padding: 0px !important;
	}
	.ant-table-summary {
		border: 1px solid rgba(0, 0, 0, 0.05);
		background: #fafafa;
		td {
			padding: 4px !important;
			border: 1px solid #59597759;
			border-right: 1px solid #aaaaaa !important;
		}
	}
	&.extra-cols {
		.ant-table-cell {
			max-width: 300px;
			&:first-child {
				min-width: 50px;
			}
		}
		.ant-table-cell-fix-right-first {
			min-width: 60px !important;
			outline: 1px solid #59597722;
		}
		.ant-table-cell-fix-right {
			max-width: 300px;
			outline: 1px solid #59597722;
		}
		th {
			&.ant-table-cell-fix-right-first {
				outline: 1px solid #595977;
			}
			&.ant-table-cell-fix-right {
				outline: 1px solid #595977;
			}
		}
	}
	&.extra-cols-ps {
		.ant-table-cell {
			max-width: 300px;
			&:first-child {
				min-width: 50px;
			}
		}
		.ant-table-cell-fix-right-first {
			outline: 1px solid #59597722;
		}
		.ant-table-cell-fix-right {
			outline: 1px solid #59597722;
		}
		th {
			&.ant-table-cell-fix-right-first {
				outline: 1px solid #595977;
			}
			&.ant-table-cell-fix-right {
				outline: 1px solid #595977;
			}
		}
	}
`;

const SharedFileLink = styled.a`
	color: blue;
	border-bottom: 1px solid blue;
`;

const TimelineDiv = styled.div`
	.ant-timeline-item-last > .ant-timeline-item-content {
		min-height: max-content;
	}
`;

const FooterButton = styled.div`
	padding: 0.5rem 1rem;
	background-color: rgba(0, 0, 0, 0.03);
	border-top: 1px solid rgba(0, 0, 0, 0.125);
	display: flex;
	justify-content: flex-end;
`;

const FooterButtonTs = styled.div`
	padding-top: 0.5rem;
	display: flex;
	justify-content: flex-end;
`;

const DropdownButton = styled.div`
	button {
		border-radius: 2px !important;
	}
`;

const DropdownButtonSearch = styled.div`
	button {
		border-radius: 2px !important;
		margin-bottom: 16px;
	}
`;

const LineDivStyle = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	margin-top: 20px;
	margin-bottom: 20px;
	.line {
		border: 1px solid #00000011;
		flex-grow: 1;
	}
	.message {
		font-weight: bold;
		font-size: 18px;
		margin-right: 10px;
		margin-left: 8px;
		color: #576670;
	}
`;

const CustomSwitch = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 4px;
	margin-bottom: 4px;
	.switch-label {
		color: rgba(0, 0, 0, 0.85);
		font-size: 13px;
	}
	button {
		margin-left: 10px;
		height: 20px;
		min-width: 25px;
		border-radius: 4px;
		.ant-switch-handle {
			height: 16px;
			width: 8px;
			::before {
				border-radius: 4px;
			}
		}
	}
	.ant-switch {
		background-color: red;
	}
	.ant-switch-checked {
		background-color: #1a7bb9;
	}
	.ant-switch-checked .ant-switch-handle {
		left: calc(100% - 8px - 2px);
	}
`;
const CustomDivider = styled.div`
	border: 1px solid #dfdfdf;
	border-style: dashed;
	width: 100%;
	margin-top: 10px;
	margin-bottom: 10px;
`;

const CustomVerticalDivider = styled.div`
	border-right: 1px solid #dfdfdf !important;
	height: 30px;
	margin-right: 10px;
	margin-left: 10px;
	margin-top: 5px;
`;

const CustomTagsDivider = styled.div`
	border-right: 1px solid #dfdfdf !important;
	height: 22px;
	margin-right: 10px;
	margin-left: 10px;
	margin-top: 5px;
`;

const FilterSearch = styled.div`
	.dropdown-container {
		z-index: 999;
	}
	.ant-form-item {
		margin-top: 10px;
		margin-left: 10px;
		margin-bottom: 0;
	}
`;

const LeftSearch = styled.div`
	display: flex;
	justify-content: flex-end;
	top: 0px;
	right: 0px;
	position: absolute;
`;

const AccountStatementSearch = styled.div`
	justify-content: flex-end;
	position: relative;
	float: right;
	width: 24%;
	margin-bottom: 10px;
`;

const LargeTableData = styled.div`
	.ant-table.ant-table-bordered .ant-table-container {
		padding: 0px;
		border: 0;
	}
	.ant-table {
		border-radius: 0;
		.ant-table-content {
			padding: 0px !important;
		}
		table {
			border-collapse: collapse;
			/* width: max-content !important; */
			min-width: 100%;
			thead {
				tr {
					th {
						background-color: #1e1e2d;
						border: 1px solid #555555 !important;
						border-top: none !important;
						color: #fff;
						padding: 5px;
						font-size: 10px;
						line-height: 1;
						text-transform: uppercase;
						word-break: break-word;
						&:last-child {
							border-bottom: none !important;
						}
					}
					&:first-child {
						th {
							border-radius: 0;
							&:first-child {
								border-radius: 0;
							}
							&:last-child {
								border-radius: 0;
							}
						}
					}
				}
			}
			tbody,
			.ant-table-tbody {
				tr {
					td {
						padding: 4px;
						font-size: 10px;
						line-height: 1;
						border: 1px solid #d3d3d3 !important;
						border-top: none !important;
					}
					td.ant-table-cell.ant-table-selection-column {
						min-width: auto;
					}
					td.ant-table-cell {
						min-width: 120px;
					}
					&.ant-table-row-selected {
						td {
							background: #c1f7d7;
							color: #000;
						}
					}
					&:hover {
						background: #c1f7d7;
						color: #000;
						.ant-table-cell-fix-left {
							background: #c1f7d7 !important;
						}
					}
				}
				tr:nth-child(even) {
					background: #e7e7e7;
				}
				tr:nth-child(odd) {
					background: #fff;
				}
				.ant-table-cell-fix-left {
					outline: 1px solid #1890ff;
				}
			}
		}
		.ant-table-body {
			border: 1px solid #d3d3d3 !important;
		}
		td.ant-table-cell-fix-right {
			outline: 1px solid #d3d3d3 !important;
		}
		th.ant-table-cell-fix-right {
			outline: 1px solid #555555 !important;
		}
		.ant-table-sticky-scroll {
			display: none !important;
		}
	}
	.ant-table-cell.mw-50 {
		min-width: 50px !important;
	}
	.ant-table-cell.mw-60 {
		min-width: 60px !important;
	}
`;

const TableData = styled.div`
	.ant-table.ant-table-bordered .ant-table-container {
		padding: 0px;
		border: 0;
	}
	.ant-table-content {
		padding: 0px !important;
	}
	.ant-table-summary {
		border: 1px solid rgba(0, 0, 0, 0.05);
		background: #fafafa;
		td {
			padding: 4px !important;
			border: 1px solid #59597759;
			border-right: 1px solid #aaaaaa !important;
		}
	}
`;
const ApsisRights = styled.a`
	font-size: 12px;
	position: absolute;
	bottom: 10px;
	right: 43%;
	z-index: 10;
	strong {
		color: #190c6b;
	}
	img {
		margin-left: 4px;
	}
`;

const CustomTableFormItem = styled.div`
	.ant-form-item-label {
		display: none;
	}
	td {
		padding: 5px 5px;
	}
	.ant-col-24 {
		padding: 0 !important;
	}
`;

export const MasterGridListOnly = styled.div`
	.ant-table-pagination.ant-pagination {
		padding: 1rem;
	}
	.mg-title-area,
	.sa-wrapper.master,
	.mg-action-rows,
	.ant-table-column-sorter,
	.ant-dropdown-trigger {
		display: none !important;
	}
	.ant-tabs-nav {
		margin-bottom: 0 !important;
	}
	.ant-table-container {
		padding-bottom: 10px !important;
	}
	th.ant-table-cell {
		padding: 6px !important;
	}
`;

export const CustomStep = styled.div`
	.ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon {
		color: white !important;
	}
	.ant-steps-item-finish .ant-steps-item-icon {
		background-color: #01893f !important;
		border-color: #01893f !important;
	}
	.ant-steps-item-icon {
		display: inline-grid !important;
		place-items: center !important;
	}
`;

export {
	AccountStatementSearch,
	AgreementButton,
	ApsisRights,
	Center,
	CustomDivider,
	CustomSwitch,
	CustomTableFormItem,
	CustomTagsDivider,
	CustomVerticalDivider,
	DangerousHtml,
	DropdownButton,
	DropdownButtonSearch,
	FilterSearch,
	FlexAccHeader,
	FooterButton,
	FooterButtonTs,
	InputSpan,
	LargeTableData,
	LeftSearch,
	LineDivStyle,
	LinkButton,
	LinkView,
	ManualGrid,
	MasterGridApi,
	NestedTableData,
	PaymentHeader,
	SharedFileLink,
	SharedManualTable,
	SharedTab,
	SharedTable,
	SharedViewData,
	SharedViewDataPlain,
	SingleSiteDiv,
	SmallerTab,
	SoftCopy,
	TabScroll,
	TableData,
	TimelineDiv,
};
